import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import {
  renderTextField,
  renderCheckbox,
  renderSelectField,
  renderDatePicker,
  renderAutoComplete
} from '../auth/form_helpers'

import '../../style/style.css';

import RaisedButton from 'material-ui/RaisedButton'
// import SelectField from 'material-ui/SelectField';
import Menu from 'material-ui/Menu';
import Popover, {PopoverAnimationVertical} from 'material-ui/Popover';
import MenuItem from 'material-ui/MenuItem';
// import Checkbox from 'material-ui/Checkbox';
// import Divider from 'material-ui/Divider';
// import TextField from 'material-ui/TextField'
// import DatePicker from 'material-ui/DatePicker';
import Paper from 'material-ui/Paper';
// import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import ActionDelete from 'material-ui/svg-icons/action/delete';
import ContentClear from 'material-ui/svg-icons/content/clear';

// import * as actionCreator from '../../actions'

// const uuidv4 = require('uuid/v4');

const styles = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
  pt15: {
    paddingTop: 15,
  },
};
var length = 0;
var length2 = 0;

class FeesForm extends Component {

  constructor(props) {
    super(props)

    // this.state = {
    //   openPopover: false
    // }
  }

  componentDidMount() {
    //  window.onbeforeunload = function (e) {
    //      e = e || window.event;
    //      // For IE and Firefox prior to version 4
    //      if (e) {
    //          e.returnValue = 'Sure?';
    //      }
    //      // For Safari
    //      return 'Sure?';
    //  };
  }

  componentWillMount() {
  }

  componentWillUnmount() {
  }

  renderAlert() {
    if (this.props.errorMessage) {
      return <div className="alert alert-danger">
        <strong>Oops: </strong>{this.props.errorMessage}
      </div>
    }
  }

  /**
    * Autocomplete handler
    *   - handleParticipantsSupervisor
    *   - handleParticipantsGroupSupervisor
    * auto input setting from Autocomplete value
    * 
  **/

  handleGroupId = (selectedItem) => {
      let items = selectedItem.value.props.value.split("|")
      this.props.change('idNewGroupid', items[1].trim())
  }

  handlePersonId = (selectedItem) => {
      let items = selectedItem.value.props.value.split("|")
      this.props.change('idNewid', items[1].trim())
  }

  renderBase(type) {
    let datasource = []
    let datasource2 = []
    let dataSourceConfig = {
      text: 'text',
      value: 'value',
    };
    if (typeof this.props.autocomplete !== 'undefined') {
      datasource = [];
      /* random lehagyja a self-knowledge group-ot a listarol. valoszinuleg túl lassu
      this.props.autocomplete.sort(function(a,b){
        if (a.positionNumber < b.positionNumber)
          return -1;
        if (a.positionNumber > b.positionNumber)
          return 1;
        return 0;
      })
      */
      this.props.autocomplete.map((option, index) => {
        datasource.push(
          {
            text: option.name,
            value: (
              <MenuItem key={index} value={option.name + ' | ' + option.id} primaryText={option.name} />
            ),
          },
        )
      })
    } else { /*console.log('autocomplete === undefined')*/ }
    if (typeof this.props.autocomplete2 !== 'undefined') {
      datasource2 = [];
      /* random lehagyja a self-knowledge group-ot a listarol. valoszinuleg túl lassu
      this.props.autocomplete2.sort(function(a,b){
        if (a.positionNumber < b.positionNumber)
          return -1;
        if (a.positionNumber > b.positionNumber)
          return 1;
        return 0;
      })
      */
      this.props.autocomplete2.map((option, index) => {
        datasource2.push(
          {
            text: option.positionNumber,
            value: (
              <MenuItem key={index} value={option.positionNumber + ' | ' + option.id} primaryText={option.positionNumber} />
            ),
          },
        )
      })
    } else { /*console.log('autocomplete2 === undefined')*/ }

    const fetch = (target, querystring, autocomplete) => {
      this.props.fetchMessage(target, querystring, autocomplete)
    };
    const fetchMore = (target, querystring, autocomplete) => {
      this.props.fetchMoreMessage(target, querystring, autocomplete)
    }
    if (typeof this.props.tracker !== 'undefined') {
      if (typeof this.props.tracker.values.typeNew !== 'undefined') {
        let tpnw = this.props.tracker.values.typeNew;
        function getAutoComplete(event) {
          if (typeof document.activeElement !== 'undefined' && typeof document.activeElement.name !== 'undefined' && typeof document.activeElement.value !== 'undefined' && length !== document.activeElement.value.length && document.activeElement.name == 'idNew') {
            length = document.activeElement.value.length
            let querystring = document.activeElement.value;
            if (tpnw === 'membership-fee') {
              fetch('/persons', '?q='+querystring, 'autocomplete')
              window.removeEventListener("keyup", getAutoComplete);
            }
            if (tpnw === 'registration-fee') {
              fetch('/persons', '?q='+querystring, 'autocomplete')
              window.removeEventListener("keyup", getAutoComplete);
            }
          }
        }
        window.addEventListener("keyup", getAutoComplete)
      }
    }
    if (typeof this.props.tracker !== 'undefined') {
      if (typeof this.props.tracker.values.typeNew !== 'undefined') {
        let tpnw = this.props.tracker.values.typeNew;
        function getAutoComplete(event) {
          if (typeof document.activeElement !== 'undefined' && typeof document.activeElement.name !== 'undefined' && typeof document.activeElement.value !== 'undefined' && length2 !== document.activeElement.value.length && document.activeElement.name == 'idNewGroup') {
            length2 = document.activeElement.value.length
            let querystring2 = document.activeElement.value;
            if (tpnw === 'group-registration-fee') {
              fetch('/groups/training', '?q='+querystring2, 'autocomplete2')
              fetchMore('/groups/self-knowledge', '?q='+querystring2, 'autocomplete2')
              window.removeEventListener("keyup", getAutoComplete);
            }
            if (tpnw === 'registration-fee') {
              fetch('/groups/training', '?q='+querystring2, 'autocomplete2')
              fetchMore('/groups/self-knowledge', '?q='+querystring2, 'autocomplete2')
              window.removeEventListener("keyup", getAutoComplete);
            }
          }
        }
        window.addEventListener("keyup", getAutoComplete)
      }
    }
    if (typeof this.props.feeinfos.editPath !== 'undefined' && typeof this.props.tracker !== 'undefined') {
      if (this.props.feeinfos.editPath.length == 36 && typeof this.props.tracker.values !== 'undefined') {
        if (typeof this.props.feetypes !== 'undefined') {
          return <Paper zDepth={1}>
              <label>Új díj típusa:</label>
              <br />
              <Field
                component={renderSelectField}
                label="típus"
                name="typeNew"
              >
                {
                  this.props.feetypes.map((option, index) => {
                    switch (option) {
                      case 'membership-fee': 
                        return <MenuItem key={index} value={option} primaryText="tagdíj" />
                      case 'registration-fee': 
                        return <MenuItem key={index} value={option} primaryText="regisztrációs díj" />
                      case 'group-registration-fee': 
                        return <MenuItem key={index} value={option} primaryText="csoport regisztrációs díj" />
                      default: 
                        return <MenuItem key={index} value={option} primaryText={option} />
                    }
                  })
                }
              </Field>
              {
                (this.props.tracker.values.typeNew === 'group-registration-fee') ? <Field
                  className="groupAutocomplete"
                  component={renderAutoComplete}
                  label="csoport"
                  name="idNewGroup"
                  dataSource={datasource2}
                  dataSourceConfig={dataSourceConfig}
                  onNewRequest={this.handleGroupId}
                >
                </Field>
                : void(0)
              }
              {
                (this.props.tracker.values.typeNew === 'membership-fee') ? <Field
                  className="personAutocomplete"
                  component={renderAutoComplete}
                  label="személy"
                  name="idNew"
                  dataSource={datasource}
                  dataSourceConfig={dataSourceConfig}
                  onNewRequest={this.handlePersonId}
                >
                </Field>
                : void(0)
              }
              {
                (this.props.tracker.values.typeNew !== 'group-registration-fee' && this.props.tracker.values.typeNew !== 'membership-fee') ? <div>
                  <Field
                    className="groupAutocomplete"
                    component={renderAutoComplete}
                    label="csoport"
                    name="idNewGroup"
                    dataSource={datasource2}
                    dataSourceConfig={dataSourceConfig}
                    onNewRequest={this.handleGroupId}
                  >
                  </Field>
                  <Field
                    className="personAutocomplete"
                    component={renderAutoComplete}
                    label="személy"
                    name="idNew"
                    dataSource={datasource}
                    dataSourceConfig={dataSourceConfig}
                    onNewRequest={this.handlePersonId}
                  >
                  </Field>
                </div>
                : void(0)
              }
              <Field
                className="hidden"
                style={{
                  display: 'none'
                }}
                component={renderTextField}
                name="idNewid"
                type="hidden"
              />
              <Field
                className="hidden"
                style={{
                  display: 'none'
                }}
                component={renderTextField}
                name="idNewGroupid"
                type="hidden"
              />
            </Paper>
        }
      }
    }
  }

  renderDate(type) {
    if (type == 'paymentDate') {
      if (typeof this.props.feeinfos.paymentDate !== 'undefined') {
        return <div>
          <Field
            className={
              typeof this.props.tracker !== 'undefined' ?
                typeof this.props.tracker.values !== 'undefined' ?
                  typeof this.props.tracker.values.paymentDate !== 'undefined' ?
                    this.props.tracker.values.paymentDate === null ? 'deleted dateInput' : 'dateInput'
                  : 'dateInput'
                : 'dateInput'
              : 'dateInput'
            }
            component={renderDatePicker}
            label="befizetés időpontja"
            floatingLabelText="befizetés időpontja"
            hintText="befizetés időpontja"
            type="text"
            style={{width: 120}}
            defaultDate={new Date(this.props.feeinfos.paymentDate)}
            name="paymentDate"
          />
          <Field
            component={renderTextField}
            className="dateText"
            floatingLabelText=""
            name="paymentDate"
            type="text"
          />
          {
            typeof this.props.tracker !== 'undefined' ?
              typeof this.props.tracker.values !== 'undefined' ?
                typeof this.props.tracker.values.paymentDate !== 'undefined' ?
                  this.props.tracker.values.paymentDate !== null ? (<div className="">
                      <IconButton onClick={this.delete("paymentDate")} className="deleteIcon">
                        <ContentClear />
                      </IconButton>
                    </div>)
                  :void(0)
                : void(0)
              : void(0)
            : void(0)
          }
        </div>
      } else {
        return <div>
          <Field
            className={
              typeof this.props.tracker !== 'undefined' ?
                typeof this.props.tracker.values !== 'undefined' ?
                  typeof this.props.tracker.values.paymentDate !== 'undefined' ?
                    this.props.tracker.values.paymentDate === null ? 'deleted dateInput' : 'dateInput'
                  : 'dateInput'
                : 'dateInput'
              : 'dateInput'
            }
            component={renderDatePicker}
            label="befizetés időpontja"
            floatingLabelText="befizetés időpontja"
            hintText="befizetés időpontja"
            type="text"
            style={{width: 120}}
            name="paymentDate"
          />
          <Field
            component={renderTextField}
            className="dateText"
            floatingLabelText=""
            name="paymentDate"
            type="text"
          />
          {
            typeof this.props.tracker !== 'undefined' ?
              typeof this.props.tracker.values !== 'undefined' ?
                typeof this.props.tracker.values.paymentDate !== 'undefined' ?
                  this.props.tracker.values.paymentDate !== null ? (<div className="">
                      <IconButton onClick={this.delete("paymentDate")} className="deleteIcon">
                        <ContentClear />
                      </IconButton>
                    </div>)
                  : void(0)
                : void(0)
              : void(0)
            : void(0)
          }
        </div>
      }
    }
    if (type == 'notice1') {
      if (typeof this.props.feeinfos.notice1 !== 'undefined') {
        return <div>
          <Field
            className={
              typeof this.props.tracker !== 'undefined' ?
                typeof this.props.tracker.values !== 'undefined' ?
                  typeof this.props.tracker.values.notice1 !== 'undefined' ?
                    this.props.tracker.values.notice1 === null ? 'deleted dateInput' : 'dateInput'
                  : 'dateInput'
                : 'dateInput'
              : 'dateInput'
            }
            component={renderDatePicker}
            label="első felszólító levél"
            floatingLabelText="első felszólító levél"
            hintText="első felszólító levél"
            type="text"
            style={{width: 120}}
            defaultDate={new Date(this.props.feeinfos.notice1)}
            name="notice1"
          />
          <Field
            component={renderTextField}
            className="dateText"
            floatingLabelText=""
            name="notice1"
            type="text"
          />
          {
            typeof this.props.tracker !== 'undefined' ?
              typeof this.props.tracker.values !== 'undefined' ?
                typeof this.props.tracker.values.notice1 !== 'undefined' ?
                  this.props.tracker.values.notice1 !== null ? (<div className="">
                      <IconButton onClick={this.delete("notice1")} className="deleteIcon">
                        <ContentClear />
                      </IconButton>
                    </div>)
                  :void(0)
                : void(0)
              : void(0)
            : void(0)
          }
        </div>
      } else {
        return <div>
          <Field
            className={
              typeof this.props.tracker !== 'undefined' ?
                typeof this.props.tracker.values !== 'undefined' ?
                  typeof this.props.tracker.values.notice1 !== 'undefined' ?
                    this.props.tracker.values.notice1 === null ? 'deleted dateInput' : 'dateInput'
                  : 'dateInput'
                : 'dateInput'
              : 'dateInput'
            }
            component={renderDatePicker}
            label="első felszólító levél"
            floatingLabelText="első felszólító levél"
            hintText="első felszólító levél"
            type="text"
            style={{width: 120}}
            name="notice1"
          />
          <Field
            component={renderTextField}
            className="dateText"
            floatingLabelText=""
            name="notice1"
            type="text"
          />
          {
            typeof this.props.tracker !== 'undefined' ?
              typeof this.props.tracker.values !== 'undefined' ?
                typeof this.props.tracker.values.notice1 !== 'undefined' ?
                  this.props.tracker.values.notice1 !== null ? (<div className="">
                      <IconButton onClick={this.delete("notice1")} className="deleteIcon">
                        <ContentClear />
                      </IconButton>
                    </div>)
                  :void(0)
                : void(0)
              : void(0)
            : void(0)
          }
        </div>
      }
    }
    if (type == 'notice2') {
      if (typeof this.props.feeinfos.notice2 !== 'undefined') {
        return <div>
          <Field
            className={
              typeof this.props.tracker !== 'undefined' ?
                typeof this.props.tracker.values !== 'undefined' ?
                  typeof this.props.tracker.values.notice2 !== 'undefined' ?
                    this.props.tracker.values.notice2 === null ? 'deleted dateInput' : 'dateInput'
                  : 'dateInput'
                : 'dateInput'
              : 'dateInput'
            }
            component={renderDatePicker}
            label="második felszólító levél"
            floatingLabelText="második felszólító levél"
            hintText="második felszólító levél"
            type="text"
            style={{width: 120}}
            defaultDate={new Date(this.props.feeinfos.notice2)}
            name="notice2"
          />
          <Field
            component={renderTextField}
            className="dateText"
            floatingLabelText=""
            name="notice2"
            type="text"
          />
          {
            typeof this.props.tracker !== 'undefined' ?
              typeof this.props.tracker.values !== 'undefined' ?
                typeof this.props.tracker.values.notice2 !== 'undefined' ?
                  this.props.tracker.values.notice2 !== null ? (<div className="">
                      <IconButton onClick={this.delete("notice2")} className="deleteIcon">
                        <ContentClear />
                      </IconButton>
                    </div>)
                  : void(0)
                : void(0)
              : void(0)
            : void(0)
          }
        </div>
      } else {
        return <div>
          <Field
            className={
              typeof this.props.tracker !== 'undefined' ?
                typeof this.props.tracker.values !== 'undefined' ?
                  typeof this.props.tracker.values.notice2 !== 'undefined' ?
                    this.props.tracker.values.notice2 === null ? 'deleted dateInput' : 'dateInput'
                  : 'dateInput'
                : 'dateInput'
              : 'dateInput'
            }
            component={renderDatePicker}
            label="második felszólító levél"
            floatingLabelText="második felszólító levél"
            hintText="második felszólító levél"
            type="text"
            style={{width: 120}}
            name="notice2"
          />
          <Field
            component={renderTextField}
            className="dateText"
            floatingLabelText=""
            name="notice2"
            type="text"
          />
          {
            typeof this.props.tracker !== 'undefined' ?
              typeof this.props.tracker.values !== 'undefined' ?
                typeof this.props.tracker.values.notice2 !== 'undefined' ?
                  this.props.tracker.values.notice2 !== null ? (<div className="">
                      <IconButton onClick={this.delete("notice2")} className="deleteIcon">
                        <ContentClear />
                      </IconButton>
                    </div>)
                  :void(0)
                : void(0)
              : void(0)
            : void(0)
          }
        </div>
      }
    }
  }

  renderText() {
    if (typeof this.props.feeinfos.type !== "undefined") {
      if (this.props.feeinfos.type == 'membership-fee') {
        return <span className="fieldStyle">év</span>
      } else if (this.props.feeinfos.type == 'registration-fee') {
        return <span className="fieldStyle">pozíciószámú csoport</span>
      } else if (this.props.feeinfos.type == 'group-registration-fee') {
        return <span className="fieldStyle">pozíciószámú csoport</span>
      } else {
        return void(0)
      }
    }
  }

  delete (text) {
    return () => {
        this.props.change(text, null)
      //this.props.onSubmit(this.refs.user.getValue(), this.refs.password.getValue())
    }
  }

  render() {
    if(typeof this.props.tracker !== 'undefined' && typeof this.props.feeinfos !== 'undefined') {
      const {handleSubmit} = this.props
      return (
        <div>
            {this.renderAlert()}
            <form onSubmit={handleSubmit} style={styles.pt15} className='formFormat' >
              {
                <div className="full">
                  <Field
                    className="itsNotAnInput toLeft"
                    component={renderTextField}
                    floatingLabelText="megnevezés"
                    name="reason"
                    disabled={true}
                    style={{
                      display: "inline-block",
                      maxWidth: 320
                    }}
                    type="text"/>
                  {this.renderText()}
                </div>
              }
              <div className='flexContainer' style={{paddingTop: 60}}>
                {this.renderBase('type')}
                <Paper zDepth={1}>
                  <label>Befizetés adatok:</label>
                  <br />
                  <Field
                    className="hidden"
                    style={{
                      display: 'none'
                    }}
                    component={renderTextField}
                    name="editPath"
                    type="hidden"
                  />
                  <Field
                    component={renderTextField}
                    floatingLabelText="a díj teljes értéke (Ft)"
                    name="amount"
                    type="text"/>
                  <Field
                    component={renderTextField}
                    floatingLabelText="befizetett összeg (Ft)"
                    name="payed"
                    type="text"/>
                  {this.renderDate('paymentDate')}
                </Paper>
                <Paper zDepth={1}>
                  <label>Számla adatok:</label>
                  <br />
                  <Field
                    component={renderTextField}
                    floatingLabelText="számla száma"
                    name="invoiceNumber"
                    type="text"/>
                  {
                    (this.props.tracker.values.typeNew === 'membership-fee' || this.props.tracker.values.typeNew === 'registration-fee' || this.props.feeinfos.type === 'membership-fee' || this.props.feeinfos.type === 'registration-fee') ? <Field
                      component={renderTextField}
                      floatingLabelText="tárgyév"
                      name="year"
                      type="text"/>
                    : void(0)
                  }
                </Paper>
                {
                  (this.props.tracker.values.typeNew === 'membership-fee' || this.props.tracker.values.typeNew === 'registration-fee' || this.props.feeinfos.type === 'membership-fee' || this.props.feeinfos.type === 'registration-fee') ? <Paper zDepth={1}>
                    <label>Tartozás:</label>
                    <br />
                    {this.renderDate('notice1')}
                    {this.renderDate('notice2')}
                    <Field
                      component={renderCheckbox}
                      label="elengedve"
                      name="isRemissed"
                      style={styles.checkbox}
                    />
                  </Paper>
                  : void(0)
                }
                <div style={{display: 'none'}}>
                  <Paper  zDepth={1} className='flexEnd p15'>
                    <RaisedButton className="FeeFormSubmitButton" type="submit" label="mentés" primary={true} labelColor={'#FFFFFF'}/>
                  </Paper>
                </div>
              </div>
            </form>
        </div>
      )
    } else{
      return (
        <div>
            {this.renderAlert()}
            <form>
              <div>.
              </div>
            </form>
        </div>
      )
    }
  }
}

const validate = values => {
  const errors = {}

  if (values.password !== values.passwordConfirmation) {
    errors.password = 'Passwords must match'
  }
    /*
  if (!values.email) {
    errors.email = 'Please enter an email'
  }
    */
  if (!values.password) {
    errors.password = 'Please enter a password'
  }

  if (!values.passwordConfirmation) {
    errors.passwordConfirmation = 'Please confirm your password'
  }

  return errors
}

FeesForm = reduxForm({
  form: 'fees',
  validate
})(FeesForm)

// You have to connect() to any reducers that you wish to connect to yourself
FeesForm = connect(
  state => ({
    initialValues: state.fees.thisfee // pull initial values from reducer
  })//,
  //{ load: loadAccount }               // bind account loading action creator
)(FeesForm)

export default FeesForm


// WEBPACK FOOTER //
// ./src/components/fees/fees_form.js